import { formatDate } from '@angular/common';
import { Component } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';

@Component({
	selector: 'app-settlement-bonus-history-detail',
	templateUrl: './settlement-bonus-history-detail.component.html',
	styleUrls: ['./settlement-bonus-history-detail.component.scss'],
})
export class SettlementBonusHistoryDetailComponent extends ShowComponent {
	protected parentComponent = 'settlements/SettlementBonusHistory';
	protected itemsBeforeDataLoad = 5;
	protected apiUrl = '/settlements/SettlementBonusHistory/';
	data = {
		editAt: null,
		editBy: null,
		json: {
			id: null,
			ownerId: null,
			name: null,
			value: null,
			isSettled: null,
			comment: null,
			date: null,
			settlementBonusNameId: null,
			terms: [],
			files: [],
			diet: 0,
			vehicleId: null,
			confirmAt: null,
			confirmBy: null,
			confirmPerson: null,
			user: null,
			confirm: null,
			confirmButton: null,
			workshop: null,
			workshopButton: null,
			valueCurrencyId: 1,
			settlementCurrencyId: 1,
			workshopBy: null,
			workshopAt: null,
			workshopComment: null,
		},
	};
	dietKind: Array<any> = [
		{ id: 0, name: '' },
		{ id: 38, name: 'Polska (stara)', disabled: true },
		{ id: 45, name: 'Polska', disabled: false },
		{ id: 50, name: 'Zagraniczna', disabled: false },
	];
	drivers: Array<any> = [];
	settlementBonusName: Array<any> = [];
	users: Array<any> = [];
	vehicles: Array<any> = [];
	currency: Array<any> = [];
	terms: Array<any> = [];

	displayedColumns: string[] = ['lp', 'month', 'value', 'comment', 'toDelete', 'dietKind'];

	labelValue = 0;

	protected loadBefore() {
		this.bag.get('/currency/?limit=50', (result, error) => {
			this.currency = result.results;
			this.loadData();
		});
		this.api.get('/settlements/settlementBonusName/', (result) => {
			this.settlementBonusName = result.data;
			this.loadData();
		});
		this.api.get('/drivers/', (result) => {
			this.drivers = result.data;
			this.loadData();
		});
		this.api.get('/vehicles/', (result) => {
			this.vehicles = result.data;
			this.loadData();
		});
		this.api.get('/users/', (result) => {
			this.users = result.data;
			this.loadData();
		});
	}

	protected convertData(data: any) {
		this.labelValue = 0;
		data.json.terms.forEach((obj) => {
			this.labelValue += parseFloat(obj.value);
		});
		const editBy_name = this.users.find((objFind) => objFind.id === data.editBy);
		data.editBy = editBy_name ? editBy_name.firstName + ' ' + editBy_name.lastName : '?';
		data.json.settlementCurrencyId = parseInt(data.json.settlementCurrencyId);
		data.json.valueCurrencyId = parseInt(data.json.valueCurrencyId);
		if (!data.json.confirmAt || !data.json.confirmAt.length) {
			data.json.confirmButton = false;
			data.json.confirm = 'nie zatwierdzono';
		} else {
			data.json.confirmButton = true;
			const confirmByUser = this.users.find((objFind) => objFind.id === data.json.confirmBy);
			const confirmByName = confirmByUser ? confirmByUser.firstName + ' ' + confirmByUser.lastName : '?';
			data.json.confirm = confirmByName + ' ' + formatDate(data.json.confirmAt, 'dd.MM.yyyy HH:mm', 'pl');
		}
		if (!data.json.workshopAt || !data.json.workshopAt.length) {
			data.json.workshopButton = false;
			data.json.workshop = 'nie zatwierdzono';
		} else {
			data.json.workshopButton = true;
			const workshopByUser = this.users.find((objFind) => objFind.id === data.json.workshopBy);
			const workshopByName = workshopByUser ? workshopByUser.firstName + ' ' + workshopByUser.lastName : '?';
			data.json.workshop = workshopByName + ' ' + formatDate(data.json.workshopAt, 'dd.MM.yyyy HH:mm', 'pl');
		}
		return data;
	}
}
